package one.healthium.uscreen.navigation.permissions

import androidx.compose.runtime.Composable

@Composable
actual fun rememberNotificationPermissionRequester(): suspend () -> Unit = {}
